function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import FieldGroup from './FieldGroup';
/**
 * Functionally the same as `FieldGroup`, but displays the form horizontally.
 *
 * @see See [FieldGroup](#fieldgroup) for API details
 */

const HorizontalFieldGroup = React.forwardRef((props, ref) => React.createElement(FieldGroup, _extends({
  theme: "light",
  variant: "light",
  ref: ref
}, props, {
  horizontal: true
})));
HorizontalFieldGroup.displayName = 'HorizontalFieldGroup';
export default HorizontalFieldGroup;